import axiosInstance from 'Shared/utilities/axiosInstance';
import {getAxiosConfig, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import {UserDetailDto} from 'Users/api';
import {UserAdministrationApi} from 'Users/api/api';

const userAdministrationApi = new UserAdministrationApi(
  undefined,
  process.env.REACT_APP_BASE_GATEWAY_URL,
  axiosInstance
);

const addUser = (user: UserDetailDto, applicationIds: number[], encryptedIdentifier?: string) =>
  withCancellation(cancelToken =>
    userAdministrationApi.addUser('1', user, applicationIds, {
      ...getAxiosConfig(cancelToken),
      params: {encryptedIdentifier},
    })
  ).then(handleResponse);

const updateUser = (user: UserDetailDto, applicationIds: number[], encryptedIdentifier?: string) =>
  withCancellation(cancelToken =>
    userAdministrationApi.updateUser('1', user, applicationIds, {
      ...getAxiosConfig(cancelToken),
      params: {encryptedIdentifier},
    })
  ).then(handleResponse);

export default {
  addUser,
  updateUser,
};
